import { useContext } from "react";
import ChannelContext from "../context";

export function useAllPanels() {
  const { state } = useContext(ChannelContext);
  return state;
}
